import React from 'react';
import { AlertTriangle, RefreshCw, LogIn } from 'lucide-react';
import { useUserAuthError } from '../../hooks/useUserAuthError';
import { Button } from '../ui/button';
import { Alert, AlertDescription } from '../ui/alert';

export const AuthErrorBanner: React.FC = () => {
  const { authErrorState, clearAuthError } = useUserAuthError();

  if (!authErrorState.hasAuthError) return null;

  const handleLoginRedirect = () => {
    clearAuthError();
    window.location.href = '/login';
  };

  const handleRefresh = () => {
    clearAuthError();
    // Trigger a re-render instead of full page reload
    window.dispatchEvent(new Event('popstate'));
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-red-50 border-b border-red-200 shadow-sm">
      <div className="container mx-auto px-4 py-3">
        <Alert variant="destructive" className="border-red-300 bg-red-50">
          <AlertTriangle className="h-4 w-4" />
          <AlertDescription>
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-2">
                {authErrorState.isRefreshing ? (
                  <>
                    <RefreshCw className="h-4 w-4 animate-spin" />
                    <span className="font-medium">Renovando sesión...</span>
                  </>
                ) : (
                  <span className="font-medium">
                    {authErrorState.errorMessage ||
                      'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.'}
                  </span>
                )}
              </div>

              {!authErrorState.isRefreshing && (
                <div className="flex gap-2 ml-4">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={handleRefresh}
                    className="border-red-300 text-red-700 hover:bg-red-100 h-8"
                  >
                    <RefreshCw className="h-3 w-3 mr-1" />
                    Reintentar
                  </Button>
                  <Button
                    size="sm"
                    onClick={handleLoginRedirect}
                    className="bg-red-600 hover:bg-red-700 text-white h-8"
                  >
                    <LogIn className="h-3 w-3 mr-1" />
                    Iniciar Sesión
                  </Button>
                </div>
              )}
            </div>
          </AlertDescription>
        </Alert>
      </div>
    </div>
  );
};
